import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import UserInfo from './UserInfo';
import { useState } from 'react';
import { Provider } from 'react-redux';
import { store } from '../../store/store';

loadDOMComponent({
	selector: 'react-user-info',
	callback: ({ container }) => {
		const userId = container.getAttribute('userId');
		const name = container.getAttribute('name') !== null;
		const firstName = container.getAttribute('firstName') !== null;
		const lastName = container.getAttribute('lastName') !== null;
		const fallbackEmail = container.getAttribute('fallbackEmail') !== null;
		const age = container.getAttribute('age') !== null;
		const gender = container.getAttribute('gender') !== null;
		const formattedGender = container.getAttribute('formattedGender') !== null;
		const city = container.getAttribute('city') !== null;
		const postCode = container.getAttribute('postCode') !== null;
		const street = container.getAttribute('street') !== null;
		const birthDate = container.getAttribute('birthDate') !== null;
		const birthNumber = container.getAttribute('birthNumber') !== null;
		const fullAddress = container.getAttribute('fullAddress') !== null;
		const formattedFullAddress =
			container.getAttribute('formattedFullAddress') !== null;
		const email = container.getAttribute('email') !== null;
		const phoneNumber = container.getAttribute('phoneNumber') !== null;
		const formattedPhoneNumber =
			container.getAttribute('formattedPhoneNumber') !== null;
		const useSpan = container.getAttribute('span') !== null;
		const badge = container.getAttribute('badge') !== null;
		const hideEmpty = container.getAttribute('hideEmpty') !== null;
		const insuranceCompany =
			container.getAttribute('insuranceCompany') !== null;
		const identificationDocumentType =
			container.getAttribute('identificationDocumentType') !== null;
		const identificationDocumentNumber =
			container.getAttribute('identificationDocumentNumber') !== null;
		const historyClinicNumber =
			container.getAttribute('historyClinicNumber') !== null;
		const nationality = container.getAttribute('nationality') !== null;
		const profession = container.getAttribute('profession') !== null;
		const specialization = container.getAttribute('specialization') !== null;
		const subSpecialization =
			container.getAttribute('subspecialization') !== null;
		const rootWorkplaceName =
			container.getAttribute('rootWorkplaceName') !== null;
		const rootWorkplaceFullAddress =
			container.getAttribute('rootWorkplaceFullAddress') !== null;
		const workplaceName = container.getAttribute('workplaceName') !== null;
		const customClass = container.getAttribute('data-class') || null;
		const emergencyContactName =
			container.getAttribute('emergencyContactName') !== null;
		const emergencyContactPhoneNumber =
			container.getAttribute('emergencyContactPhoneNumber') !== null;
		const showLabel = container.getAttribute('showLabel') !== null;
		const workplaceFullAddress =
			container.getAttribute('workplaceFullAddress') !== null;
		const listenSocket = container.getAttribute('listenSocket') !== null;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<UserInfo
						userId={userId}
						name={name}
						firstName={firstName}
						lastName={lastName}
						age={age}
						city={city}
						street={street}
						postCode={postCode}
						birthDate={birthDate}
						birthNumber={birthNumber}
						email={email}
						phoneNumber={phoneNumber}
						formattedPhoneNumber={formattedPhoneNumber}
						fullAddress={fullAddress}
						formattedFullAddress={formattedFullAddress}
						fallbackEmail={fallbackEmail}
						customClass={customClass}
						useSpan={useSpan}
						badge={badge}
						hideEmpty={hideEmpty}
						insuranceCompany={insuranceCompany}
						gender={gender}
						identificationDocumentType={identificationDocumentType}
						identificationDocumentNumber={identificationDocumentNumber}
						historyClinicNumber={historyClinicNumber}
						formattedGender={formattedGender}
						nationality={nationality}
						profession={profession}
						specialization={specialization}
						subSpecialization={subSpecialization}
						rootWorkplaceName={rootWorkplaceName}
						rootWorkplaceFullAddress={rootWorkplaceFullAddress}
						emergencyContactName={emergencyContactName}
						emergencyContactPhoneNumber={emergencyContactPhoneNumber}
						showLabel={showLabel}
						workplaceName={workplaceName}
						workplaceFullAddress={workplaceFullAddress}
						listenSocket={listenSocket}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
